import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Alert, Box, Button, Stack, TextField } from '@mui/material'
import { useAuth } from '~/api/auth'
import { Title } from '~/components'
import { showToast } from '~/utils'

const ForgotPassword = () => {
  const { forgotPassword } = useAuth({
    middleware: 'guest',
    // redirectIfAuthenticated: '/',
  })
  const { t } = useTranslation()
  const [errorMessage, setErrorMessage] = useState()

  const onSubmit = useCallback(
    async (e) => {
      e.preventDefault()
      const data = Object.fromEntries(new FormData(e.target).entries())
      const result = await forgotPassword({
        setErrorMessage,
        ...data,
      })
      if (result) {
        showToast(t('auth.reset.sent'), { variant: 'success' })
      }
    },
    [forgotPassword, t]
  )

  return (
    <div className="flex justify-center items-center">
      <Box
        component="form"
        noValidate
        autoComplete="off"
        sx={{ maxWidth: '400px', width: '100%' }}
        onSubmit={onSubmit}
      >
        <Stack spacing={4}>
          <Title>{t('auth.reset.title')}</Title>
          <Stack spacing={2}>
            <TextField label={t('auth.email')} name="email" type="email" />
            <Button variant="contained" type="submit">
              {t('auth.reset.send-link')}
            </Button>
            {errorMessage && <Alert severity="error">{errorMessage}</Alert>}
          </Stack>
        </Stack>
      </Box>
    </div>
  )
}

export default ForgotPassword
